import { render } from "./ExisistedCaseInfo.vue?vue&type=template&id=b739a204"
import script from "./ExisistedCaseInfo.vue?vue&type=script&lang=js"
export * from "./ExisistedCaseInfo.vue?vue&type=script&lang=js"

import "./ExisistedCaseInfo.vue?vue&type=style&index=0&id=b739a204&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/ExisistedCaseInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b739a204"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b739a204', __exports__)) {
    console.log('reload')
    api.reload('b739a204', __exports__)
  }
  
  module.hot.accept("./ExisistedCaseInfo.vue?vue&type=template&id=b739a204", () => {
    console.log('re-render')
    api.rerender('b739a204', render)
  })

}


export default __exports__